/* eslint-disable max-lines-per-function */
import createUser from 'src/dataLayer/remoteData/babbelAPI/createUser';
import { getPostVerificationRedirect } from './getPostVerificationRedirect';
import { ErrorInterface, SubmitParamsType, isUserType } from './types';
import { NodeInputs } from 'src/dataLayer/remoteData/babbelAPI/createUser/types';
import { getUserResponseToQuestion } from 'src/viewLayer/components/nodes/PageNode/InfoPage/getUserResponseToQuestion';
import { reportEmptyUserRegistrationAttempt } from 'src/dataLayer/remoteData/rollbar';

export const handleSubmit = async (
  {
    setInProgress,
    currentInput,
    userInput,
    setUserInput,
    nodeInputs,
    goToNextNode,
    learnLang,
    emailVerificationTarget,
    setUserData,
    trackingInfo,
    flowId,
    invitationToken
  }: SubmitParamsType,
  token?: string
): Promise<void> => {
  setInProgress(true);

  const submittedUserInput: {[keys: string]: string} = {};
  const errorInterface = {} as ErrorInterface;

  // create errorInterface for easier error handling & submittedUserInput to update user state
  for (const inputName  of Object.keys(currentInput) as NodeInputs) {
    submittedUserInput[inputName] = currentInput[inputName]?.inputValue;
    errorInterface[inputName] = currentInput[inputName]?.setErrorMessage;
  }

  const updatedUserInput = {
    ...userInput,
    ...submittedUserInput
  };

  const updateUserInput = (): void => setUserInput(updatedUserInput);

  const postVerificationRedirect = getPostVerificationRedirect({
    userInput,
    learnLang,
    flowId,
    emailVerificationTarget
  });

  const cefrLevel = getUserResponseToQuestion(userInput, 'language_level') === 'notMuch' ? 'A1.1' : undefined;

  const user = await createUser({
    postVerificationRedirect,
    email: updatedUserInput.email,
    errorInterface,
    firstname: updatedUserInput.firstname,
    nodeInputs,
    password: updatedUserInput.password,
    learnLang,
    trackingInfo,
    token,
    cefrLevel,
    ...(invitationToken && { invitationToken }),
    callback: updateUserInput
  });

  if (user) {
    if (isUserType(user)) {
      // reset userInput since the user was successfully registered
      setUserInput({});
      // store user to state - to be consumed in RedirectNode
      setUserData(user.user);
    } else {
      void reportEmptyUserRegistrationAttempt(user);
    }
    // reset previously rendered error messages
    for (const inputName of nodeInputs) currentInput[inputName]?.resetErrorMessage();
    goToNextNode();
  }

  setInProgress(false);
};
